import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Paper from '@mui/material/Paper';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

Answer.propTypes = {
  activity: PropTypes.string.isRequired,
  answerText: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default function Answer({ activity, header, answerText }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Paper sx={{ backgroundColor: '#eaebed', borderRadius: '15px' }}>
      <div className="wb-frmvld fieldflow-lg wb-init wb-frmvld-inited wb-fieldflow-form" id="paper">
        <div className="mrgn-tp-md">
          <div id="answer" style={{ padding: isMobile ? '16px' : '25px' }}>
            <fieldset
              id="acts"
              className="alert alert-info"
              style={{ margin: 0 }}
            >
              {activity !== undefined && (
                <h3 style={{
                  fontSize: isMobile ? '16px' : '20px',
                  lineHeight: 1.4,
                  marginTop: 0,
                  marginBottom: '8px',
                }}>
                  <i>{activity}</i>
                </h3>
              )}
              <p style={{
                fontSize: isMobile ? '16px' : '20px',
                lineHeight: 1.5,
                marginBottom: '8px',
              }}>
                <b>{parse(header)}</b>
              </p>
              <p style={{
                fontSize: isMobile ? '14px' : '16px',
                lineHeight: 1.6,
                marginBottom: 0,
              }}>
                {answerText === undefined ? null : parse(answerText)}
              </p>
            </fieldset>
          </div>
        </div>
      </div>
    </Paper>
  );
}